import { render } from "./PinModalEdit.vue?vue&type=template&id=65475ecf&scoped=true"
import script from "./PinModalEdit.vue?vue&type=script&lang=js"
export * from "./PinModalEdit.vue?vue&type=script&lang=js"

import "./PinModalEdit.vue?vue&type=style&index=0&id=65475ecf&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-65475ecf"

export default script